import { Text, Title } from "@mantine/core";
import { PDFPage } from "./PDFPage";
import useReportStore from "../../../store/useReportStore";

export const HigherPositionsPDF = () => {
  const { report } = useReportStore();
  if (!report.higher_positions.mark_down) return null;

  return (
    <PDFPage padding>
      <Title size={44} mb={8}>
        {report.higher_positions.mark_down
          ? report.higher_positions.mark_down.replace("##", "")
          : ""}
      </Title>
      <Text mb={48} size="24px" lh="42px" c="dimmed">
        {report.higher_positions.explanation
          ? report.higher_positions.explanation
          : ""}
      </Text>
      <div className="pdf-piramid">
        {report.higher_positions.data.map((position, index) => (
          <div className={`triangle triangle-${index + 1}`} key={index}>
            <Text size="20px">{position.title}</Text>
          </div>
        ))}
      </div>
      {report.higher_positions?.data.map((position, index) => (
        <Text mt={20} size="22px" lh="30px" key={index}>
          <b>{position.title}</b>: {position.description}
        </Text>
      ))}
    </PDFPage>
  );
};
